import { SET_COMPANIES } from '../types';

export const setCompanies = (data) => (dispatch) => {
  dispatch({
    type: SET_COMPANIES,
    payload: data,
  });
};
